<template>
  <div class="service-page-container">
    <div class="banner-container">
      <div class="title service-page-show">
        <span>服务内容</span>
        <span>Service</span>
        <span
        >为客户提供一站式服务，用丰富的行业经验与产品经验打造落地的产品</span
        >
      </div>
    </div>
    <div class="exhibit-content-card-container service-page-enter">
      <div class="exhibit-content-card">
        <div class="content-type-container">
          <div
            class="content-type service-page-img-show"
            :class="{ active: checkTypeIndex == index }"
            v-for="(item, index) in serviceData"
            :key="index"
            @click="checkTypeIndexChange(index)"
          >
            <div class="logo">
              <img
                :src="checkTypeIndex == index ? item.activeImgUrl : item.imgUrl"
                alt=""
              />
            </div>
            <div class="name">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <!-- 产品策略展示区域 -->
        <transition
          v-for="item in serviceContentData"
          :key="item.id"
          name="navShow"
        >
          <div class="content-container" v-show="checkTypeIndex == item.id - 1">
            <div class="title">
              <span>{{ item.name }}</span>
              <span>{{ item.desc }}</span>
            </div>
            <div class="content-card-container">
              <div
                class="content-card"
                v-for="childItem in item.children"
                :key="childItem.id"
              >
                <div class="logo">
                  <img :src="childItem.logoUrl" alt=""/>
                </div>
                <div class="name">
                  <span>{{ childItem.name }}</span>
                </div>
                <div class="content">
                  <span>{{ childItem.desc }}</span>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="service-content-container">
      <div class="title service-page-enter">
        <span>用完整的服务周期用心打磨每一个产品</span>
      </div>
      <div class="service-process">
        <div
          class="process-card service-page-img-show"
          v-for="(item, index) in processData"
          :key="index"
        >
          <span>{{ item.name }}</span>
          <span>{{ item.English }}</span>
        </div>
      </div>
      <div class="background-container">
        <img src="@/assets/image/service-background.png" alt=""/>
      </div>
    </div>
    <contact-us></contact-us>
  </div>
</template>

<script>
  import contactUs from "@/components/contactUs";
  import scrollReveal from "scrollreveal";

  export default {
    components: {
      contactUs,
    },
    data() {
      return {
        scrollReveal: scrollReveal(),
        serviceData: [
          {
            name: "产品策略",
            imgUrl: require("@/assets/image/icon-strategy-blue.png"),
            activeImgUrl: require("@/assets/image/icon-strategy-white.png"),
          },
          {
            name: "产品设计",
            imgUrl: require("@/assets/image/icon-design-blue.png"),
            activeImgUrl: require("@/assets/image/icon-design-white.png"),
          },
          {
            name: "视觉设计",
            imgUrl: require("@/assets/image/icon-vision-blue.png"),
            activeImgUrl: require("@/assets/image/icon-vision-white.png"),
          },
          {
            name: "品牌设计",
            imgUrl: require("@/assets/image/icon-brand-blue.png"),
            activeImgUrl: require("@/assets/image/icon-brand-white.png"),
          },
          {
            name: "产品开发",
            imgUrl: require("@/assets/image/icon-develop-blue.png"),
            activeImgUrl: require("@/assets/image/icon-develop-white.png"),
          },
        ],
        processData: [
          {
            name: "需求沟通",
            English: "Demand Communication",
          },
          {
            name: "产品设计",
            English: "Product Design",
          },
          {
            name: "技术开发",
            English: "Technological Development",
          },
          {
            name: "项目测试",
            English: "Project Testing",
          },
          {
            name: "项目交付",
            English: "Project Delivery",
          },
          {
            name: "项目维护",
            English: "Project Maintenance",
          },
        ],
        serviceContentData: [
          {
            id: 1,
            name: "产品策略",
            desc: "精准捕捉趋势，为企业提供创新型产品策略",
            children: [
              {
                id: 11,
                name: "需求分析",
                desc: "标杆分析、概念图、思维导图、设计研讨会、核心诉求分析",
                logoUrl: require("@/assets/image/icon-demand.png"),
              },
              {
                id: 12,
                name: "用户研究",
                desc: "影子观察、问卷调查、角色扮演、用户访谈、极端用户研究",
                logoUrl: require("@/assets/image/icon-user.png"),
              },
              {
                id: 13,
                name: "体验创新",
                desc: "需求优化、服务模式探索、策略组合创新、设计语言创新",
                logoUrl: require("@/assets/image/icon-innovate.png"),
              },
              {
                id: 14,
                name: "策略完善",
                desc: "用户体验调研反馈、客户体验考核体系、二次产品优化",
                logoUrl: require("@/assets/image/icon-perfect.png"),
              },
            ],
          },
          {
            id: 2,
            name: "产品设计",
            desc: "掌握用户极致的体验，提供优雅的产品设计方案",
            children: [
              {
                id: 21,
                name: "思维导图",
                desc: "产品架构设计、产品功能规划、用户体验流程、关系网络",
                logoUrl: require("@/assets/image/icon-swdt.png"),
              },
              {
                id: 22,
                name: "低保真原型",
                desc: "界面研究、操作流程可视化、用户体验行为分析",
                logoUrl: require("@/assets/image/icon-bzyx.png"),
              },
              {
                id: 23,
                name: "流程体验",
                desc: "可交互体验文件、多角色体验反馈、二次交互体验优化",
                logoUrl: require("@/assets/image/icon-lcty.png"),
              },
            ],
          },
          {
            id: 3,
            name: "视觉设计",
            desc: "精准分析设计趋势，把控产品体验与美的平衡点",
            children: [
              {
                id: 31,
                name: "移动界面",
                desc: "多设备尺寸适配、交互体验优化、多元化创新设计",
                logoUrl: require("@/assets/image/icon-ydym.png"),
              },
              {
                id: 32,
                name: "网页设计",
                desc: "多端自适应、响应式网页、多元化创新设计、全类别设计方案",
                logoUrl: require("@/assets/image/icon-wysj.png"),
              },
              {
                id: 33,
                name: "桌面应用",
                desc: "多元化创新设计、全类别设计方案、用户体验优化",
                logoUrl: require("@/assets/image/icon-zmyy.png"),
              },
            ],
          },
          {
            id: 4,
            name: "品牌设计",
            desc: "升级企业品牌形象，品牌价值直观有效的传播",
            children: [
              {
                id: 41,
                name: "企业VI系统",
                desc: "品牌分析、内部访谈、企业价值定位分析、场景模拟",
                logoUrl: require("@/assets/image/icon-VI.png"),
              },
              {
                id: 42,
                name: "标志设计",
                desc: "品牌分析、多方案研讨、企业价值定位分析、应用模拟",
                logoUrl: require("@/assets/image/icon-bzsj.png"),
              },
              {
                id: 43,
                name: "平面设计",
                desc: "需求分析、应用场景分析、受众群体调研、视觉反馈优化",
                logoUrl: require("@/assets/image/icon-pmsj.png"),
              },
            ],
          },
          {
            id: 5,
            name: "产品开发",
            desc: "追求高品质原生应用体验，高性能的自有技术架构",
            children: [
              {
                id: 51,
                name: "小程序开发",
                desc: "媲美原生应用体验、多平台应用、服务器配置、系统测试",
                logoUrl: require("@/assets/image/icon-wxapp.png"),
              },
              {
                id: 52,
                name: "中后台开发",
                desc: "多类型项目支持、高性能自主架构、服务器配置、系统测试",
                logoUrl: require("@/assets/image/icon-htkf.png"),
              },
              {
                id: 53,
                name: "APP开发",
                desc: "双平台应用适配、100%原生编程规范、应用商店上架",
                logoUrl: require("@/assets/image/icon-appkf.png"),
              },
              {
                id: 14,
                name: "网站开发",
                desc: "多端适配优化、灵活可扩展、最新的编程范例、长期维护",
                logoUrl: require("@/assets/image/icon-wzkf.png"),
              },
            ],
          },
        ],
        checkTypeIndex: 0,
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.scrollReveal.reveal(".service-page-enter", {
          duration: 200,
          delay: 0,
          interval: 0,
          origin: "bottom",
          viewOffset: {
            bottom: 20,
          },
          reset: false,
          mobile: false,
          distance: "50px",
          opacity: 0.0,
          easing: "linear",
          scale: 0.99,
        });
        this.scrollReveal.reveal(".service-page-show", {
          duration: 250,
          delay: 0,
          interval: 100,
          origin: "bottom",
          viewOffset: {
            bottom: 100,
          },
          reset: false,
          mobile: false,
          distance: "50px",
          opacity: 0.0,
          easing: "linear",
          scale: 1,
        });
        this.scrollReveal.reveal(".service-page-card-show", {
          duration: 200,
          delay: 0,
          interval: 50,
          origin: "bottom",
          viewOffset: {
            bottom: 100,
          },
          reset: false,
          mobile: false,
          distance: "50px",
          opacity: 0.0,
          easing: "linear",
          scale: 1,
        });
        this.scrollReveal.reveal(".service-page-img-show", {
          duration: 200,
          delay: 0,
          interval: 50,
          origin: "bottom",
          viewOffset: {
            bottom: 50,
          },
          reset: false,
          mobile: false,
          distance: "0",
          opacity: 0.0,
          easing: "linear",
          scale: 0.8,
        });
      });
    },
    methods: {
      checkTypeIndexChange(index) {
        this.checkTypeIndex = index;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .navShow-enter-active {
    transition: opacity 0.6s;
  }

  .navShow-enter {
    opacity: 0;
  }

  .service-page-container {
    width: 100%;
    overflow: hidden;

    .banner-container {
      background: url("../../../assets/image/main-background.png") no-repeat;
      background-size: 100% 100%;
      position: relative;
      height: 726px;
      display: flex;
      justify-content: center;
      align-items: center;

      .title {
        // padding-top: 243px;
        span {
          display: block;
          font-family: PingFangSC-Semibold;
          font-size: 40px;
          color: #ffffff;
          text-align: center;
        }

        span + span {
          font-family: PingFangSC-Semibold;
          font-size: 30px;
          color: #0057ff;
          text-align: center;
        }

        span + span + span {
          margin-top: 40px;
          font-family: PingFangSC-Medium;
          font-size: 20px;
          color: #ffffff;
        }
      }
    }

    .exhibit-content-card-container {
      position: relative;

      .exhibit-content-card {
        width: 1200px;
        height: 727px;
        margin: 0 auto;
        padding: 20px;
        background: #ffffff;
        box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.06);
        transform: translateY(-73px);
        overflow: hidden;

        .content-type-container {
          display: flex;
          justify-content: space-between;

          .content-type {
            width: 220px;
            height: 170px;
            background-image: linear-gradient(180deg, #282828 0%, #000000 100%);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            user-select: none;

            .logo {
              img {
                display: block;
                width: 50px;
                height: 50px;
              }
            }

            .name {
              margin-top: 30px;
              font-family: PingFangSC-Semibold;
              font-size: 24px;
              color: #ffffff;
            }

            &:hover {
              transform: translateY(-10px) !important;
            }
          }

          .active {
            background: #0057ff;
          }
        }

        .content-container {
          margin-top: 80px;

          .title {
            span {
              display: block;
              font-family: PingFangSC-Semibold;
              font-size: 40px;
              color: #000000;
              text-align: center;
            }

            span + span {
              margin-top: 20px;
              font-family: PingFangSC-Regular;
              font-size: 20px;
              color: #000000;
            }
          }

          .content-card-container {
            margin-top: 120px;
            display: flex;
            justify-content: space-evenly;

            .content-card {
              width: 200px;
              text-align: center;

              .logo {
                img {
                  height: 58px;
                  margin: 0 auto;
                }
              }

              .name {
                margin-top: 13px;
                font-family: PingFangSC-Medium;
                font-size: 18px;
                color: #000000;
              }

              .content {
                margin-top: 20px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #818181;
                text-align: justify;
              }
            }
          }
        }
      }
    }

    .service-content-container {
      max-width: 1200px;
      margin: 0 auto;

      .title {
        margin-top: 77px;
        font-family: PingFangSC-Semibold;
        font-size: 40px;
        color: #000000;
        text-align: center;
      }

      .service-process {
        margin-top: 100px;
        display: flex;
        justify-content: center;
        align-items: center;

        .process-card {
          width: 160px;
          margin-right: 40px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          span {
            display: block;
            font-family: PingFangSC-Medium;
            font-size: 20px;
            color: #000000;
          }

          span + span {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #808080;
            text-align: center;
          }
        }

        :last-child {
          margin-right: 0;
        }
      }

      .background-container {
        margin-top: 40px;
        height: 500px;
        background: #fff;

        img {
          height: 400px;
          position: relative;
          left: 50%;
          margin-left: -1100px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/details/components/servicePage.vue